<script lang="ts">
  import Icon from './Icon.svelte'
  import Skeleton from './Skeleton.svelte'

  export let alt: string
  export let src: string | undefined = undefined
  export let size: number | undefined = undefined
  let image: HTMLImageElement | undefined = undefined
  let imgLoading = true

  $: if (image?.complete) {
    imgLoading = false
  }
</script>

<div class="avatar" style={size ? `--avatar-size: ${size}em` : undefined}>
  <div class="portrait">
    {#if src}
      <img
        bind:this={image}
        on:load={() => (imgLoading = false)}
        {src}
        {alt}
        class:imgLoading
      />
      <Skeleton visible={imgLoading} />
    {:else}
      <Icon icon="ph-user-circle" size={size ?? 2.5} />
    {/if}
  </div>

  {#if $$slots.badge}
    <div class="badge">
      <slot name="badge" />
    </div>
  {/if}
</div>

<style lang="scss">
  .avatar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: var(--avatar-size, 2.5em);
    width: var(--avatar-size, 2.5em);
    height: var(--avatar-size, 2.5em);
    aspect-ratio: 1 / 1;
    padding: 0;
    user-select: none;

    .portrait {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
      --icon-margin: 0;

      img {
        height: 100%;
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        opacity: 1;
        transition: opacity 175ms ease-in;

        &.imgLoading {
          opacity: 0;
        }
      }
    }

    .badge {
      position: absolute;
      left: 0;
      bottom: 0;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
